export function getAnimatedCardImageWidth(width: number): number {
  // we multiply by 1.5 to support smooth transformation
  const imageWidth = width * 1.5;
  return imageWidth;
}
